import { useMemo, useState } from "react";

const useUserFilters = (users) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [deliveryAddressFilter, setDeliveryAddressFilter] = useState("");
  const [emailModeFilter, setEmailModeFilter] = useState("all");
  const [smsModeFilter, setSmsModeFilter] = useState("all");

  const filteredUsers = useMemo(() => {
    let filtered = users;

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (user) =>
          user.firstName.toLowerCase().includes(searchLower) ||
          user.lastName.toLowerCase().includes(searchLower) ||
          user.toAddress.toLowerCase().includes(searchLower) ||
          user.deliveryAddress.toLowerCase().includes(searchLower) ||
          user.mobileNumber.includes(searchTerm) ||
          (user.voicemailNumber && user.voicemailNumber.includes(searchTerm)),
      );
    }

    if (deliveryAddressFilter) {
      const filterLower = deliveryAddressFilter.toLowerCase();
      filtered = filtered.filter((user) =>
        user.deliveryAddress.toLowerCase().includes(filterLower),
      );
    }

    if (emailModeFilter && emailModeFilter !== "all") {
      filtered = filtered.filter((user) => user.emailMode === emailModeFilter);
    }

    if (smsModeFilter && smsModeFilter !== "all") {
      filtered = filtered.filter((user) => user.smsMode === smsModeFilter);
    }

    return filtered;
  }, [users, searchTerm, deliveryAddressFilter, emailModeFilter, smsModeFilter]);

  return {
    searchTerm,
    setSearchTerm,
    deliveryAddressFilter,
    setDeliveryAddressFilter,
    emailModeFilter,
    setEmailModeFilter,
    smsModeFilter,
    setSmsModeFilter,
    filteredUsers,
  };
};

export default useUserFilters;
